import React, { useState, useEffect, useRef } from 'react'
import { Card, Row, Col, Popover } from 'antd'
import { InfoCircleOutlined } from '@ant-design/icons'
import { useSelector } from 'react-redux'
import moment from 'moment'
import dayjs from 'dayjs'
import { getNddcBindReport, getNddcBindSummary, exportNddcBindReport } from '@/services/rfid/nddc/nddcRfidBindReport'
import { configQuery } from '@/services/configuration/config'
import AntdTable from '@/components/table/AntdTable'
import SearchBar from '@/components/searchbar/SearchBar'
import {
  numFormat,
  paginationInit,
  formatMessageNew,
  downLoadFileBlob,
  formatStartTime,
  formatEndTime,
  dateFormatYearMonthDay,
  isChineseFun
} from '@/utils/common'
const startMonth = dayjs().subtract(1, 'months')
const endMonth = dayjs()
const NddcRfidBindReport = () => {
  const deviceSize = useSelector(state => state.commonStore.deviceSize)
  const BIND_STATUS = [
    // { value: '0', label: () => formatMessageNew(`languageObj.qrCode.boundCarton0`) },
    { value: '1', label: () => formatMessageNew(`languageObj.qrCode.boundCarton1`) },
    { value: '2', label: () => formatMessageNew(`languageObj.qrCode.boundCarton2`) },
    { value: '3', label: () => formatMessageNew(`languageObj.qrCode.boundCarton3`) },
    { value: '4', label: () => formatMessageNew(`languageObj.qrCode.boundCarton4`) }
  ]
  const mounting = useRef(false)
  let formRef = useRef(null)
  const [tableList, setTableList] = useState([])
  const [tableListTotal, setTableListTotal] = useState([])
  let searchListInit = [
    {
      type: 'timeRange',
      label: 'languageObj.nddcRfidBindReport.updateDate',
      key: 'timeRange',
      format: dateFormatYearMonthDay,
      isdefaultfilter: 'true',
      disabledDate: current => {
        let falg = current && current > moment().endOf('day')
        return falg
      },
      initialValues: [startMonth, endMonth],
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'select',
      label: 'languageObj.nddcRfidBindReport.status',
      key: 'cartonStatus',
      allowClear: true,
      initialValues: null,
      // mode: 'multiple',
      // maxTagCount: 1,
      selectList: BIND_STATUS,
      isdefaultfilter: 'true',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'select',
      label: 'languageObj.commonLocale.plant',
      key: 'plantCode',
      allowClear: true,
      initialValues: null,
      // mode: 'multiple',
      // maxTagCount: 1,
      selectList: [],
      isdefaultfilter: 'true',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.nddcRfidBindReport.platformOrderNo',
      key: 'platformOrderNumber',
      initialValues: '',
      isdefaultfilter: 'true',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.nddcRfidBindReport.giOrderNo',
      key: 'giOrderNumber',
      initialValues: '',
      isdefaultfilter: 'true',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.nddcRfidBindReport.bzOmsOrderNo',
      key: 'omsOrderNumber',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.commonLocale.productName',
      key: 'productName',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.commonLocale.productCode',
      key: 'productCode',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.commonLocale.cartonNo',
      key: 'cartonNumber',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.commonLocale.upc',
      key: 'upc',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.nddcRfidBindReport.rfidEpc',
      key: 'rfidEpc',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.commonLocale.qrCode',
      key: 'qrCode',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.nddcRfidBindReport.carrierTrackingNo',
      key: 'carrierTrackingNo',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      }
    }
  ]
  const [searchList, setSearchList] = useState(searchListInit)
  const [queryFlag, setQueryFlag] = useState(false)
  const [pagination, setPagination] = useState(paginationInit)
  const tableColumnsTotal = [
    {
      title: formatMessageNew('languageObj.commonLocale.plant'),
      dataIndex: 'plantCode',
      width: 80
    },
    {
      title: formatMessageNew('languageObj.nddcRfidBindReport.actualTotalBinds'),
      dataIndex: 'actualTotalBinds',
      width: 100,
      render: text => {
        return numFormat(text)
      }
    },
    {
      title: formatMessageNew('languageObj.nddcRfidBindReport.rfidBinds'),
      dataIndex: 'rfidBinds',
      width: 100,
      render: text => {
        return numFormat(text)
      }
    },
    {
      title: formatMessageNew('languageObj.nddcRfidBindReport.qrBinds'),
      dataIndex: 'qrBinds',
      width: 100,
      render: text => {
        return numFormat(text)
      }
    }
  ]
  const tableColumns = [
    {
      title: <div className="p8">{formatMessageNew(`languageObj.qrCode.statusSignal`)}</div>,
      dataIndex: 'statusSignal',
      width: 100,
      fixed: 'left',
      className: 'statusSignal',
      render: (text, record) => {
        if (record.cartonStatus === '0') {
          return (
            <div className="displayFlex justifyContentCenter">
              <div className="bgcb notbind"></div>
            </div>
          )
        } else if (record.cartonStatus === '1') {
          return (
            <div className="displayFlex justifyContentCenter">
              <div className="bgcb bindInProgress"></div>
            </div>
          )
        } else if (record.cartonStatus === '2') {
          return (
            <div className="displayFlex justifyContentCenter">
              <div className="bgcb bound"></div>
            </div>
          )
        } else if (record.cartonStatus === '3') {
          return (
            <div className="displayFlex justifyContentCenter">
              <div className="bgcb unbind"></div>
            </div>
          )
        } else if (record.cartonStatus === '4') {
          return (
            <div className="displayFlex justifyContentCenter">
              <div className="bgcb forcceBinding"></div>
            </div>
          )
        }
      }
    },
    {
      title: formatMessageNew('languageObj.qrCode.itemSstatus'),
      dataIndex: 'status',
      width: 100,
      render: text => {
        return <div className="word_break_all">{formatMessageNew(`languageObj.qrCode.bound${text}`)}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.commonLocale.plant'),
      dataIndex: 'plantCode',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.commonLocale.cartonNo'),
      dataIndex: 'cartonNumber',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.qrCode.productCode'),
      dataIndex: 'productCode',
      width: 120,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.commonLocale.upc'),
      dataIndex: 'upc',
      width: 120,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.nddcRfidBindReport.rfidEpc'),
      dataIndex: 'rfidEpc',
      width: 100,
      render: (text, record) => {
        if (record.status === 2) {
          return <div className="word_break_all textLineThrough">{text}</div>
        } else {
          return <div className="word_break_all">{text}</div>
        }
      }
    },
    {
      title: formatMessageNew('languageObj.commonLocale.qrCode'),
      dataIndex: 'qrCode',
      width: 100,
      render: (text, record) => {
        if (record.status === 2) {
          return <div className="word_break_all textLineThrough">{record.globalQrCode || record.localQrCode}</div>
        } else {
          return <div className="word_break_all">{record.globalQrCode || record.localQrCode}</div>
        }
      }
    },
    {
      title: formatMessageNew('languageObj.commonLocale.productName'),
      dataIndex: 'productName',
      width: 120,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },

    {
      title: formatMessageNew('languageObj.nddcRfidBindReport.platformOrderNo'),
      dataIndex: 'platformOrderNumber',
      width: 150,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.nddcRfidBindReport.giOrderNo'),
      dataIndex: 'giOrderNumber',
      width: 120,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.nddcRfidBindReport.bzOmsOrderNo'),
      dataIndex: 'omsOrderNumber',
      width: 140,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },

    {
      title: formatMessageNew('languageObj.nddcRfidBindReport.carrierTrackingNo'),
      dataIndex: 'carrierTrackingNo',
      width: 150,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.nddcRfidBindReport.updateDate'),
      dataIndex: 'updateTime',
      width: 100,
      render: text => {
        return moment(new Date(text)).format(dateFormatYearMonthDay)
      }
    }
  ]
  useEffect(() => {
    getOptionList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const getOptionList = () => {
    let num = 99999
    const params2 = {
      configKey: 'plant_code',
      // configStatus: true,
      configType: 'plant_code_config',
      pageNo: 1,
      size: num,
      total: num
    }

    Promise.all([configQuery(params2)]).then(res => {
      try {
        searchList.forEach(searchItem => {
          if (['plantCode'].includes(searchItem.key)) {
            let options = []
            switch (searchItem.key) {
              case 'plantCode':
                const plantCodeList = res[0].resultData.records
                options = plantCodeList.map(item => ({ value: item.configValue, label: item.configValue }))
                break
              default:
                break
            }
            searchItem.selectList = options
          }
        })
        setSearchList([...searchList])
      } catch (error) {}
    })
  }
  useEffect(() => {
    if (mounting.current) {
      searchDataFun()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryFlag])
  const searchDataBtn = () => {
    const pg = {
      ...pagination,
      currentPage: 1
    }
    mounting.current = true
    setPagination(pg)
    setQueryFlag(!queryFlag)
  }
  const searchClearDataBtn = () => {
    // formRef && formRef.current.clearForm()
    const pg = {
      ...pagination,
      currentPage: 1,
      total: 0
    }
    setPagination(pg)
    setTableList([])
    setTableListTotal([])
    formRef && formRef.current.setValue({ timeRange: [] })
    // setQueryFlag(!queryFlag)
  }

  const getParams = () => {
    const info = (formRef.current && formRef.current.getSearchValue()) || {}
    const params = {
      ...info,
      startUpdateDate: formatStartTime(info.timeRange),
      endUpdateDate: formatEndTime(info.timeRange)
    }
    delete params.timeRange
    return params
  }

  const searchDataFun = () => {
    const params = {
      ...getParams(),
      size: pagination.pageSize,
      pageNo: pagination.currentPage
    }
    getNddcBindSummary(params).then(res => {
      let dt = res.resultData
      setTableListTotal(dt)
    })
    getNddcBindReport(params).then(res => {
      const dt = res.resultData
      const records = dt.records
      setTableList(records)
      const pg = {
        ...pagination,
        total: dt.total
      }
      setPagination(pg)
    })
  }
  const handleTableChange = pagina => {
    const params = {
      ...pagination,
      currentPage: pagina.current,
      pageSize: pagina.pageSize
    }
    setPagination({ ...params })
    setQueryFlag(!queryFlag)
  }
  const downLoadFun = () => {
    const params = {
      ...getParams(),
      ...isChineseFun()
    }
    exportNddcBindReport(params).then(res => {
      downLoadFileBlob(res)
    })
  }
  const getPopoverContent = () => {
    return (
      <div>
        <div dangerouslySetInnerHTML={{ __html: formatMessageNew('languageObj.nddcRfidBindReport.definition1') }}></div>
        <div
          className="mt10"
          dangerouslySetInnerHTML={{ __html: formatMessageNew('languageObj.nddcRfidBindReport.definition2') }}
        ></div>
      </div>
    )
  }
  return (
    <Card bodyStyle={{ padding: 4 }}>
      <div className="search-bar">
        <SearchBar
          ref={formRef}
          searchList={searchList}
          showCollapseBtn={true}
          showSearchBtn={true}
          showClearBtn={true}
          onSearch={searchDataBtn}
          onClear={searchClearDataBtn}
        />
      </div>

      <div className="content-container">
        <Row type="flex" justify="center">
          <Col span={17}>
            <AntdTable bordered columns={tableColumnsTotal} dataSource={tableListTotal} />
          </Col>
        </Row>
        <div className="mt30 pt10">
          <Popover
            trigger="click"
            color="#f5f5f5"
            className="cursorPointer"
            overlayStyle={{
              maxWidth: '50vw',
              maxHeight: '95vh',
              overflow: 'auto',
              borderRadius: 8
            }}
            placement="right"
            content={getPopoverContent()}
          >
            <InfoCircleOutlined style={{ fontSize: 18 * deviceSize, marginBottom: 10 * deviceSize }} />
          </Popover>
          <AntdTable
            dataSource={tableList}
            columns={tableColumns}
            // 独一无二的标识，不能重复
            columnsKey="columns_nddcRfidBindReport"
            pagination={pagination}
            onDownload={downLoadFun}
            onChange={handleTableChange}
          />
        </div>
      </div>
    </Card>
  )
}
export default NddcRfidBindReport
